import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid"
import { useConsultationCalendarEvents } from "./calendarQueries"
import dayjs from 'dayjs'
import CalendarEvent from "./CalendarEvent"

export type Props = {
  customerId?: number
}

const ConsultationsCalendar = ({customerId} : Props) => {
  const consultationsCalendarEvents =  useConsultationCalendarEvents(customerId)
  const consultations = consultationsCalendarEvents.data ?? []

  const renderEventContent = (eventInfo: any) => {
    return <CalendarEvent eventInfo={eventInfo} />
  }

  if(consultationsCalendarEvents.isLoading){
    return <div>Loading...</div>
  }

  return <FullCalendar
          plugins={[dayGridPlugin]}
          initialView="dayGridMonth"
          headerToolbar={{
            left: "prev,next today",
            center: "title",
            right: "dayGridMonth,dayGridWeek,dayGridDay",
          }}
          events={consultations.map((consultation) => ({ 
            title: consultation.title, 
            start: consultation.start, 
            end: consultation.end,
            color: consultation.color,
            display: "block",
            allDay: consultation.allDay,
            originalEvent: consultation
           }))}
           eventClick={(info) => {
            const startDate = dayjs(info.event.extendedProps.originalEvent.start)
            const consultationId = info.event.extendedProps.originalEvent.consultationId
            const projectId = info.event.extendedProps.originalEvent.projectId
            const workarea = info.event.extendedProps.originalEvent.workarea
            const workareaId = info.event.extendedProps.originalEvent.workarea?.id

            let mainCalendarEventUrl = `/#!/calendar?date=${startDate.format('YYYYMMDD')}`
            mainCalendarEventUrl += info.event.extendedProps.originalEvent.consultationId ? 
              `&consultationId=${consultationId}` : 
              `&project=${projectId}&task=${workarea ? 
                  workareaId : 
                  ''}`;
            window.open(mainCalendarEventUrl);
           }}
          eventContent={renderEventContent}
          slotMinTime={"06:00:00"}
          slotMaxTime={"22:00:00"}
          eventStartEditable={false}
          views={{
            agendaDay: {
              columnFormat: "dddd MMMM DD"
            },
            agendaWeek: {
              columnFormat: "ddd MM/DD"
            }
          }}
        />
}

export default ConsultationsCalendar